import { ActionReducerMapBuilder, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IRequestState } from "../request.state.interface";
import getDrawsHandler from "./get-draws.handler";
import { IDraw } from "../../pages/DrawPage/DrawItem";
import buyDrawTicketHandler from "./buy-ticket.handler";
import confirmDrawWinHandler from "./confirm-win.handler";
import getDrawsWinnersHandler, { IDrawsWinners } from "./get-winners.handler";

export interface IGetDrawsStat {
    winnersCount: number;
    rewardTotal: number;
}

export interface IDrawsState extends IRequestState {
    items: IDraw[];
    winners: IDrawsWinners;
    stat: IGetDrawsStat;
    fragments: number;
    fragmentsPrizes: number;
};

const initialState: IDrawsState = {
    items: [],
    winners: {
        data: [],
        pagination: null,
    },
    stat: {
        winnersCount: 0,
        rewardTotal: 0,
    },
    fragments: 0,
    fragmentsPrizes: 0,

    loading: false,
    error: "",
};

const drawsSlice = createSlice({
    name: 'draws',
    initialState,
    reducers: {
        setFragments: (state, action: PayloadAction<number>) => {
            state.fragments = action.payload;
        },
    },
    extraReducers: (builder: ActionReducerMapBuilder<IDrawsState>) => {
        getDrawsHandler(builder);
        buyDrawTicketHandler(builder);
        confirmDrawWinHandler(builder);
        getDrawsWinnersHandler(builder);
    },
});

export default drawsSlice.reducer;
export const { setFragments } = drawsSlice.actions;